import { render, staticRenderFns } from "./chartererDetention.vue?vue&type=template&id=5466094a"
import script from "./chartererDetention.vue?vue&type=script&lang=js"
export * from "./chartererDetention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports